// extracted by mini-css-extract-plugin
export default {"root":"TierRestrictionSelection_root__yYByF","select":"TierRestrictionSelection_select__-0KYk"};